<template>
    <div id="history-view-container">
        <div id="history-container" class="mb-4" :class="{'history-container-inner-padding': !$store.state.clinicHistory.sidebarHidden}">
            <history-wrapper :id="sidebarData.appointmentHistory.id" :title="$t('appointmentsHistory')" :sideBarTrigger="sideBarTrigger.appointmentHistory">
                <appointment-history></appointment-history>
            </history-wrapper>
            <history-wrapper :id="sidebarData.diseases.id" overflowVisible :title="$t('diseases')" hideTitleOnOpen :sideBarTrigger="sideBarTrigger.diseases">
                <history-diseases-section></history-diseases-section>
            </history-wrapper>
            <history-wrapper :id="sidebarData.chronicDiseases.id" overflowVisible :title="$t('chrondiseases')" hideTitleOnOpen :sideBarTrigger="sideBarTrigger.chronicDiseases" v-if="!$route.query.petId">
                <history-chrondiseases-section></history-chrondiseases-section>
            </history-wrapper>
            <history-wrapper :id="sidebarData.medication.id" overflowVisible :title="$t('currentMedication')" hideTitleOnOpen :sideBarTrigger="sideBarTrigger.medication">
                <history-medicines-section></history-medicines-section>
            </history-wrapper>
            <history-wrapper :id="sidebarData.pastMedication.id" overflowVisible :title="$t('pastMedication')" hideTitleOnOpen :sideBarTrigger="sideBarTrigger.pastMedication">
                <history-medicines-section past></history-medicines-section>
            </history-wrapper>
            <history-wrapper :id="sidebarData.medicationAllergies.id" overflowVisible :title="$t('allergies')" hideTitleOnOpen :sideBarTrigger="sideBarTrigger.medicationAllergies">
                <history-med-allergies-section></history-med-allergies-section>
            </history-wrapper>
            <history-wrapper :id="sidebarData.allergies.id" overflowVisible :title="$t('otherAllergies')" hideTitleOnOpen :sideBarTrigger="sideBarTrigger.allergies">
                <history-allergies-section></history-allergies-section>
            </history-wrapper>
            <history-wrapper :id="sidebarData.observations.id" :title="$t('observations')" :sideBarTrigger="sideBarTrigger.observations">
                <history-observations-section></history-observations-section>
            </history-wrapper>
            <history-wrapper :id="sidebarData.significantEvents.id" :title="$t('relvantsExperiences')" :sideBarTrigger="sideBarTrigger.significantEvents" v-if="!$route.query.petId">
                <history-events-section></history-events-section>
            </history-wrapper>
            <history-wrapper :id="sidebarData.vaccines.id" overflowVisible :title="$t('vaccines')" hideTitleOnOpen :sideBarTrigger="sideBarTrigger.vaccines">
                <history-vaccines-section></history-vaccines-section>
            </history-wrapper>
            <history-wrapper :id="sidebarData.familyBackground.id" overflowVisible :title="$t('familyhistory')" hideTitleOnOpen :sideBarTrigger="sideBarTrigger.familyBackground" v-if="!$route.query.petId">
                <history-familybackgrounds-section></history-familybackgrounds-section>
            </history-wrapper>
        </div>
    </div>
</template>

<script>
import HistoryWrapper from '@/components/views/clinicHistory/ClinicHistorySectionWrapper'
import { MENU_PATH } from '@/constants/clinicHistory'
import AppointmentHistory from '@/components/shared/AppointmentHistory.vue'
import HistoryAllergiesSection from '@/components/shared/HistoryAllergiesSection.vue'
import HistoryMedAllergiesSection from '@/components/shared/HistoryMedAllergiesSection.vue'
import HistoryDiseasesSection from '@/components/shared/HistoryDiseasesSection.vue'
import HistoryChrondiseasesSection from '@/components/shared/HistoryChrondiseasesSection.vue'
import HistoryVaccinesSection from '@/components/shared/HistoryVaccinesSection.vue'
import HistoryMedicinesSection from '@/components/shared/HistoryMedicinesSection.vue'
import HistoryFamilybackgroundsSection from '@/components/shared/HistoryFamilybackgroundsSection.vue'
import HistoryObservationsSection from '@/components/shared/HistoryObservationsSection.vue'
import HistoryEventsSection from '@/components/shared/HistoryEventsSection.vue'
import clinicHistoryMixin from '@/mixins/clinicHistory.mixin'
import layoutMixin from '@/mixins/layout.mixin'

export default {
    components: {
        HistoryWrapper,
        AppointmentHistory,
        HistoryAllergiesSection,
        HistoryMedAllergiesSection,
        HistoryDiseasesSection,
        HistoryChrondiseasesSection,
        HistoryVaccinesSection,
        HistoryMedicinesSection,
        HistoryFamilybackgroundsSection,
        HistoryObservationsSection,
        HistoryEventsSection
    },
    props: {
    },
    mixins: [clinicHistoryMixin, layoutMixin],
    data () {
        return {
            showGrantAccessHistoryModal: false,
            observations: null,
            expandSidebar: false,
            sidebarKey: 0,
            leftSideLiHeight: null,
            sideBarTrigger: {
                healthVars: 0,
                otherHealthVars: 0,
                diseases: 0,
                chronicDiseases: 0,
                pastMedication: 0,
                medication: 0,
                appointmentHistory: 0,
                observations: 0,
                significantEvents: 0,
                habits: 0,
                mood: 0,
                healthyHabits: 0,
                selfTest: 0,
                allergies: 0,
                medicationAllergies: 0,
                vaccines: 0,
                familyBackground: 0
            },
            grantAccess: {
                show: false
            },
            MENU_PATH
        }
    },
    created () {
        this.load()
        window.scrollTo(0, 0)
    },
    methods: {
        openHistorySection (section) {
            this.sideBarTrigger[section]++
        },
        load () {
        },
        refreshSidebar () {
            this.sidebarKey++
        }
    },
    computed: {
        showGrantHistoryAccess () {
            return this.$store.getters['session/userIsPatient'] && this.$store.state.clinicHistory.sidebarHidden
        },
        readOnlyView () {
            return !!this.$route.query.t
        },
        sidebarDataRight () {
            let _this = this
            return this.$store.state.session.user && this.$store.state.session.user.havePets ? {
                selectPatient: {
                    title: this.$t('clinic-history.select-patient'),
                    id: 'changeUser',
                    action () {
                        _this.changeUserModalVisible = true
                    }
                },
                selectPet: {
                    title: this.$t('clinic-history.select-pet'),
                    id: 'pet',
                    action () {
                        _this.changePetModalVisible = true
                    }
                },
                grantAccess: {
                    title: this.$t('clinic-history.grant-access'),
                    id: 'accessHistory',
                    action () {
                        _this.grantAccess.show = true
                    }
                },
                professionalsAuthorized: {
                    title: this.$t('clinic-history.access-authorizated'),
                    id: 'authorizedAccess',
                    action () {
                        _this.showProfAndCenterAuthorizedModal = true
                    }
                },
                back: {
                    title: this.$t('back'),
                    id: 'leftArrow',
                    action () {
                        _this.goToSection(MENU_PATH)
                    },
                    back: true,
                    hideHr: true
                }
            } : this.$store.getters['session/userIsProfessional'] || this.historyReadOnly ? {
                back: {
                    title: this.$t('back'),
                    id: 'leftArrow',
                    action () {
                        _this.goToSection(MENU_PATH)
                    },
                    back: true,
                    hideHr: true
                }
            } : {
                selectPatient: {
                    title: this.$t('clinic-history.select-patient'),
                    id: 'changeUser',
                    action () {
                        _this.changeUserModalVisible = true
                    }
                },
                grantAccess: {
                    title: this.$t('clinic-history.grant-access'),
                    id: 'accessHistory',
                    action () {
                        _this.grantAccess.show = true
                    }
                },
                professionalsAuthorized: {
                    title: this.$t('clinic-history.access-authorizated'),
                    id: 'authorizedAccess',
                    action () {
                        _this.showProfAndCenterAuthorizedModal = true
                    }
                },
                back: {
                    title: this.$t('back'),
                    id: 'leftArrow',
                    action () {
                        _this.goToSection(MENU_PATH)
                    },
                    back: true,
                    hideHr: true
                }
            }
        },
        sidebarData () {
            return this.$route.query.petId ? {
                appointmentHistory: {
                    title: this.$t('appointmentsHistory'),
                    id: 'appointmentHistory'
                },
                diseases: {
                    title: this.$t('diseases'),
                    id: 'diseases'
                },
                medication: {
                    title: this.$t('currentMedication'),
                    id: 'medication'
                },
                pastMedication: {
                    title: this.$t('pastMedication'),
                    id: 'pastMedication'
                },
                medicationAllergies: {
                    title: this.$t('allergies'),
                    id: 'medicationAllergies'
                },
                allergies: {
                    title: this.$t('otherAllergies'),
                    id: 'allergies'
                },
                observations: {
                    title: this.$t('observations'),
                    id: 'observations'
                },
                vaccines: {
                    title: this.$t('vaccines'),
                    id: 'vaccines'
                }
            } : {
                appointmentHistory: {
                    title: this.$t('appointmentsHistory'),
                    id: 'appointmentHistory'
                },
                diseases: {
                    title: this.$t('diseases'),
                    id: 'diseases'
                },
                chronicDiseases: {
                    title: this.$t('chrondiseases'),
                    id: 'chronicDiseases'
                },
                medication: {
                    title: this.$t('currentMedication'),
                    id: 'medication'
                },
                pastMedication: {
                    title: this.$t('pastMedication'),
                    id: 'pastMedication'
                },
                medicationAllergies: {
                    title: this.$t('allergies'),
                    id: 'medicationAllergies'
                },
                allergies: {
                    title: this.$t('otherAllergies'),
                    id: 'allergies'
                },
                observations: {
                    title: this.$t('observations'),
                    id: 'observations'
                },
                significantEvents: {
                    title: this.$t('relvantsExperiences'),
                    id: 'significantEvents'
                },
                vaccines: {
                    title: this.$t('vaccines'),
                    id: 'vaccines'
                },
                familyBackground: {
                    title: this.$t('familyhistory'),
                    id: 'familyBackground',
                    hideHr: true
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.history-container-inner-padding{
    padding-left: 2rem;
    padding-right: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/views/clinicHistory/ClinicHistoryView.vue